// @ts-nocheck
import SingleMatchCard from '../specific_ppv_year_info_component/single_match_card_in_info_ppv_folder/SingleMatchCard';
import TripleMatchCard from '../specific_ppv_year_info_component/single_match_card_in_info_ppv_folder/TripleMatchCard';
import TagMatchCard from '../specific_ppv_year_info_component/single_match_card_in_info_ppv_folder/TagMatchCard';
import FatalMatchCard from '../specific_ppv_year_info_component/single_match_card_in_info_ppv_folder/FatalMatchCard';
import SixMatchCard from '../specific_ppv_year_info_component/single_match_card_in_info_ppv_folder/SixMatchCard';
import ThreeTagMatchCard from '../specific_ppv_year_info_component/single_match_card_in_info_ppv_folder/ThreeTagMatchCard';
import HandicapMatchCard from '../specific_ppv_year_info_component/single_match_card_in_info_ppv_folder/HandicapMatchCard';
import RumbleMatchCard from '../specific_ppv_year_info_component/single_match_card_in_info_ppv_folder/RumbleMatchCard';
import SixFiveTagMatchCard from '../specific_ppv_year_info_component/single_match_card_in_info_ppv_folder/SixFiveTagMatchCard';
import NwoMatchCard from '../specific_ppv_year_info_component/single_match_card_in_info_ppv_folder/NwoMatchCard';
import ThreeVsThreeMatchCard from '../specific_ppv_year_info_component/single_match_card_in_info_ppv_folder/ThreeVsThreeMatchCard';
import FourVsFourMatchCard from '../specific_ppv_year_info_component/single_match_card_in_info_ppv_folder/FourVsFourMatchCard';
import FiveVsFiveMatchCard from '../specific_ppv_year_info_component/single_match_card_in_info_ppv_folder/FiveVsFiveMatchCard';
import SixVsSixMatchCard from '../specific_ppv_year_info_component/single_match_card_in_info_ppv_folder/SixVsSixMatchCard';
import DefaultMatchCard from '../specific_ppv_year_info_component/single_match_card_in_info_ppv_folder/DefaultMatchCard';
import { useNavigateToWrestler as navigateToWrestlerFunction } from '../ui_components/ApiFunctionJsUtilities';

// A seconda del type_match, renderizza il match
const renderFightType = (matchInfo, keyMatchInfo, navigateToWrestler) => {

    if(!navigateToWrestler) {
        // è uguale alla callback della funzione navigateToWrestler
        navigateToWrestler = navigateToWrestlerFunction;
    }
    
    const { type_match } = matchInfo;
    switch (type_match.type) {
        case 'single':
            return <SingleMatchCard key={keyMatchInfo} matchInfo={matchInfo} navigateToWrestler={navigateToWrestler} />;
        case 'triple':
            return <TripleMatchCard key={keyMatchInfo} matchInfo={matchInfo} navigateToWrestler={navigateToWrestler} />;
        case 'tag':
            return <TagMatchCard key={keyMatchInfo} matchInfo={matchInfo} navigateToWrestler={navigateToWrestler} />;
        case 'fatal':
            return <FatalMatchCard key={keyMatchInfo} matchInfo={matchInfo} navigateToWrestler={navigateToWrestler} />;
        case 'five':
            return <SixMatchCard key={keyMatchInfo} matchInfo={matchInfo} navigateToWrestler={navigateToWrestler} />;
        case 'six':
            return <SixMatchCard key={keyMatchInfo} matchInfo={matchInfo} navigateToWrestler={navigateToWrestler} />;
        case 'three_tag':
            return <ThreeTagMatchCard key={keyMatchInfo} matchInfo={matchInfo} navigateToWrestler={navigateToWrestler} />;
        case 'four_tag':
            return <ThreeTagMatchCard key={keyMatchInfo} matchInfo={matchInfo} navigateToWrestler={navigateToWrestler} />;
        case 'six_tag':
            return <SixFiveTagMatchCard key={keyMatchInfo} matchInfo={matchInfo} navigateToWrestler={navigateToWrestler} />;
        case 'five_tag':
            return <SixFiveTagMatchCard key={keyMatchInfo} matchInfo={matchInfo} navigateToWrestler={navigateToWrestler} />;
        case 'handicap':
            return <HandicapMatchCard key={keyMatchInfo} matchInfo={matchInfo} navigateToWrestler={navigateToWrestler} />;
        case 'rumble':
            return <RumbleMatchCard key={keyMatchInfo} matchInfo={matchInfo} navigateToWrestler={navigateToWrestler} />;
        case 'special':
            // se type_matchname inizia con NWO renderizza NWCMatchCard altrimenti renderizza DefaultMatchCard
            if (type_match.name.toLowerCase().startsWith('nwo')) {
                return <NwoMatchCard key={keyMatchInfo} matchInfo={matchInfo} navigateToWrestler={navigateToWrestler} />;
            } else if(type_match.name.toLowerCase() == 'elimination chamber') {
                return <SixMatchCard key={keyMatchInfo} matchInfo={matchInfo} navigateToWrestler={navigateToWrestler} />;
            } else if (type_match.name.toLowerCase() == '3 vs 3') {
                return <ThreeVsThreeMatchCard key={keyMatchInfo} matchInfo={matchInfo} navigateToWrestler={navigateToWrestler} />;
            } else if (type_match.name.toLowerCase() == '4 vs 4') {
                return <FourVsFourMatchCard key={keyMatchInfo} matchInfo={matchInfo} navigateToWrestler={navigateToWrestler} />;
            } else if (type_match.name.toLowerCase() == '5 vs 5') {
                return <FiveVsFiveMatchCard key={keyMatchInfo} matchInfo={matchInfo} navigateToWrestler={navigateToWrestler} />;
            } else if (type_match.name.toLowerCase() == '6 vs 6') {
                return <SixVsSixMatchCard key={keyMatchInfo} matchInfo={matchInfo} navigateToWrestler={navigateToWrestler} />;
            } else {
                return <DefaultMatchCard key={keyMatchInfo} matchInfo={matchInfo} />;
            }
        default:
            return <DefaultMatchCard key={keyMatchInfo} matchInfo={matchInfo} />;
    }
}

export default renderFightType;